// matriset datepicker using ui-bootstrap
// Dependency on netwintie/matriweb constants makes this netwintie specific but
// it seems like the easiest way to customize finnish / swedish variants
// Could consider using f.e. angular locales instead for more generic solution
//
// NOTE: used also with VOSK, imported directly there
DpUibDirective.$inject = ['$compile', 'Constants'];
// Adds a date input wrapped as bootstrap input group
//
// Usage
// <ma-datepicker ng-model="vm.prcToEdit.establishedDate" ig-class="col-sm-3 col-md-2"></ma-datepicker>
//
// ig-class: these are appended to class attribute of input-group
//  - typically you will want something like ig-class="col-sm-3 col-md-2" for non-inline forms
//  - can also add input-group-sm to have smaller controls
//
// ig-style: set as style attribute of input group
//  - use to set f.e. explicit widths. ig-style="width: 120px" (or125) is good for input-group-sm
//
// possible to give id and name for the actual input
//  <ma-datepicker id="xyz" name="xyz" required>
export default function DpUibDirective($compile, Constants) {
    var buildTemplate = function (scope, attrs) {
        const id = attrs.id || 'edt' + scope.$id;
        const name = attrs.name || id;
        const inputFormAttr = attrs.form ? `form="${attrs.form}"` : '';
        let igClass = 'input-group';
        if (attrs.igClass) {
            igClass += ' ' + attrs.igClass;
        }
        const igStyleAttr = attrs.igStyle ? `style="${attrs.igStyle}"` : '';
        const formats = (Constants.lang == 'sv-se') ?
            'uib-datepicker-popup="yyyy-MM-dd" alt-input-formats="[\'yyyy-M!-d!\']"' :
            'uib-datepicker-popup="d.M.yyyy" alt-input-formats="[\'d!.M!.yyyy\']"';
        const html = [];
        html.push(`<div class="${igClass}" ${igStyleAttr} >`);
        html.push(`<input type="text" class="form-control" ${inputFormAttr} ${formats} ng-model="dt" ng-model-options="{ getterSetter: true }" is-open="isOpen" datepicker-options="dateOptions" ng-required="required" current-text="Tänään" clear-text="Tyhjennä" close-text="Sulje" id="${id}" name="${name}" />`);
        html.push('<span class="input-group-btn">');
        html.push('<button type="button" class="btn btn-default" ng-click="isOpen=true"><i class="glyphicon glyphicon-calendar"></i></button>');
        html.push('</span>');
        html.push('</div>');
        return html.join('\n');
    }; // buildTemplate
    var linker = function linker(scope, element, attrs, ctrls) {
        if (attrs.required !== undefined) {
            scope.required = true;
        }
        scope.dateOptions = {
            dateFormat: 'd.m.yy' // displayed format
        };
        // getter/setter function for date (used with ui-bootstrap datetime picker)
        scope.dt = function (val) {
            if (arguments.length) {
                scope.cached = val;
                if (val) {
                    // TZ offset must be taken into account so that resulting string has date
                    // in user local timezone. In Finland the naive val.toISOString().substr(0,10)
                    // fails 22-24 when offset is 2hours. Resulting value will be off by one day.
                    var tzoffset = val.getTimezoneOffset() * 60000; //offset in milliseconds
                    scope.ngModel = (new Date(val.getTime() - tzoffset)).toISOString().substr(0, 10);
                }
                else {
                    scope.ngModel = undefined;
                }
            }
            else {
                if (!scope.cached && scope.ngModel) {
                    // update cached if not done
                    scope.cached = new Date(scope.ngModel);
                }
                return scope.cached;
            }
        };
        // idea from:
        // http://onehungrymind.com/angularjs-dynamic-templates/
        // more ideas from ma-ol-map olMapToolbar implementation
        element.html(buildTemplate(scope, attrs)).show();
        $compile(element.contents())(scope);
    }; // linked
    return {
        restrict: 'E',
        replace: false,
        //require: ['^form' /*, 'ngModel'*/], // ngModel would give us the ngModel _CONTROLLER_, which can used to bind watches etc.
        require: 'ngModel',
        scope: {
            ngModel: '=', // 'ng-model="xyz"' => we get xyz as our scope.ngModel variable
        },
        link: linker
    };
} // DpUibDirective
